// API & socket: runtime-resolved to current origin so each domain
// (wepurplay.com, wepurplay.ru, in-touch.space) hits its own /api/ and
// /socket.io/. Avoids cross-origin to a single hardcoded host (was
// https://in-touch.space) which breaks .ru users when in-touch.space
// is unreachable, and adds RU-routing latency for international users.
// Env vars retained as SSR/test fallback.
const isBrowser = typeof window !== "undefined" && window.location && window.location.origin;

const config = {
  backendUrl: isBrowser
    ? `${window.location.origin}/api/`
    : process.env.REACT_APP_BACKEND_URL,
  socketUrl: isBrowser
    ? window.location.origin
    : process.env.REACT_APP_SOCKET_URL,
  domain: process.env.REACT_APP_DOMAIN,
  prod_domain: process.env.REACT_APP_PROD_DOMAIN,
  // Invite/share base link: includes /game/ on in-touch.space (legacy URL
  // structure) and on localhost (CRA dev server serves under /game/ per
  // package.json `homepage`), root on wepurplay.* domains where the /game/
  // prefix was dropped.
  generatedBaseLink:
    typeof window !== "undefined" && window.location && window.location.origin
      ? `${window.location.origin}${
          window.location.hostname.endsWith("in-touch.space") ||
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1"
            ? "/game/"
            : "/"
        }`
      : process.env.REACT_APP_GENERATED_BASE_LINK,
  // Card images: relative path on prod (nginx proxies /static-api/ to api on every domain),
  // on dev — overridable via REACT_APP_STATIC_API_URL (локальный API с картинками
  // в server/static), фолбэк — прод, чтобы не ловить 404 на пустом static.
  staticApiUrl:
    process.env.NODE_ENV === "production"
      ? "/static-api/"
      : process.env.REACT_APP_STATIC_API_URL ||
        "https://in-touch.space/static-api/",
  facebookLink: false,
  emailLink: true,
  vkGroupLink: process.env.REACT_APP_VK_LINK,
  spaceIntouchMail: process.env.REACT_APP_SPACEINTOUCH_MAIL,
  reCaptchaKey: process.env.REACT_APP_RECAPTCHA_KEY,
  hideResetGame: false,
  hideRemoveGame: false,
  terminalKey: process.env.REACT_APP_TERMINAL_KEY,
  totalCards: "88",
  priceRub: process.env.REACT_APP_PRICE_RUB,
  priceUsd: process.env.REACT_APP_PRICE_USD,
  tokenSecretPassphrase: process.env.REACT_APP_TOKEN_SECRET_PASSPHRASE,

  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  vapidKey: process.env.REACT_APP_FIREBASE_WEB_VAPIDKEY,

  // Sentry configuration
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  sentryEnvironment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development",
  sentryTracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
  sentryReplaySessionSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE || "0.1"),
  sentryReplayErrorSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE || "1.0"),
};

export default config;
